var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9nn0i6d3ta)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44.27 14.682-6.953-6.954a2.49 2.49 0 0 0-3.522 0l-19.19 19.191a2.467 2.467 0 0 0-.73 1.76v6.956a2.49 2.49 0 0 0 2.49 2.49h6.955a2.467 2.467 0 0 0 1.76-.73l19.19-19.19a2.491 2.491 0 0 0 0-3.522zm-5.495 5.496-6.955-6.954 3.735-3.735 6.955 6.954-3.735 3.735z",
    fill: "#405EDC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.769 4.333h-4.334C8.602 4.333 4.27 8.666 4.27 19.5v13c0 10.833 4.333 15.166 15.166 15.166h13c10.834 0 15.167-4.333 15.167-15.166v-4.334",
    stroke: "#405EDC",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9nn0i6d3ta"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9.5 7.5)",
    d: "M0 0h35v35H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIcon2);
export default __webpack_public_path__ + "static/media/penIcon2.f4f659f8193f09e52ba2a111644fd660.svg";
export { ForwardRef as ReactComponent };